import React, {Component} from 'react'
import PropTypes from 'prop-types'
import NRTVerticalStack from "../../_common/_containers/VerticalStack"
import NRTHorizontalStack from "../../_common/_containers/HorizontalStack"
import NRTFormInput from "../../_common/_form/FormInput"
import {Validators} from "../../_common/_form/Validators"
import _ from 'lodash'
import debounce from 'debounce'

class MCSaleFormResponsible extends Component {

    state = {
        password: '',
        canProceed: false,
    }


    componentDidMount() {
        this.setState({
            needToCheckIfCpfAlreadyInUse: !this.props.person
        })
    }


    updateAddress(address) {
        const {
            bairro,
            localidade,
            logradouro,
            uf

        } = address


        this.neighborhoodInput.setValue(bairro)
        this.cityInput.setValue(localidade)
        this.streetInput.setValue(logradouro)
        this.stateInput.setValue(uf)
    }


    passwordChanged = (name, value) => {
        this.setState({password: value})
    }

    passwordChangedDebounced = debounce(this.passwordChanged, 200)

    confirmPasswordValidate = () => {
        return value => {

            if (this.state.password === value)
                return null

            return 'Senhas não conferem.'
        }
    }


    render() {


        const {
            cpfCnpj,
            name,
            email,
            phoneOne,
            phoneTwo,
            profession,
            addressDTO

        } = this.props.person || {}

        //console.log(this.props)
        const newUser = !this.props.person

        return (
            <NRTVerticalStack>


                <NRTFormInput label={'CPF*'}
                              name={'responsible.cpfCnpj'}
                              type={newUser ? 'cpf' : 'hidden'}
                              value={cpfCnpj}
                              validators={[
                                  Validators.cpfOrCnpj()
                              ]}

                />


                {
                    this.props.cpfAlreadyInUse &&
                    <div className="nrt-form-error-msg">
                        Este CPF já está sendo utilizado.
                    </div>
                }


                {
                    newUser &&

                    <NRTHorizontalStack smFractions={[]}>
                        <NRTFormInput
                            name={'responsible.password'}
                            label={'Senha*'}
                            validators={[
                                Validators.required()
                            ]}
                            onChange={this.passwordChangedDebounced}
                            customProps={{
                                type: 'password'
                            }}

                        />

                        <NRTFormInput
                            name={'responsible.confirmPassword'}
                            label={'Confirmar senha*'}
                            validators={[
                                this.confirmPasswordValidate()
                            ]}
                            customProps={{
                                type: 'password'
                            }}

                        />
                    </NRTHorizontalStack>
                }


                <NRTHorizontalStack smFractions={[]}>
                    {
                        <NRTFormInput
                            name={'responsible.name'}
                            label={'Nome Completo*'}
                            validators={[
                                Validators.required(),
                                Validators.personName()
                            ]}
                            value={name}
                            disabled={!newUser}
                        />
                    }


                    <NRTFormInput
                        name={'responsible.email'}
                        label={'E-mail*'}
                        validators={[Validators.email()]}
                        value={email}
                    />
                </NRTHorizontalStack>

                <NRTHorizontalStack fractions={[1, 1]}>
                    <NRTFormInput
                        name={'responsible.phoneOne'}
                        label={'Tel 1*'}
                        validators={[
                            Validators.required(),
                            Validators.phone()
                        ]}
                        value={phoneOne}
                        type={'phone'}
                    />

                    <NRTFormInput
                        name={'responsible.phoneTwo'}
                        label={'Tel 2'}
                        validators={[Validators.phone()]}
                        value={phoneTwo || ''}
                        type={'phone'}
                    />
                </NRTHorizontalStack>

                <NRTFormInput
                    name={'responsible.profession'}
                    label={'Profissão'}
                    value={profession}
                />

                <NRTFormInput
                    name={'responsible.addressDTO.cep'}
                    label={'CEP*'}
                    type={'cep'}
                    validators={[Validators.cep()]}
                    value={_.get(addressDTO, 'cep')}
                />

                <NRTHorizontalStack fractions={[2, 1, 1]} smFractions={[2, 1]}>
                    <NRTFormInput
                        name={'responsible.addressDTO.street'}
                        label={'Rua*'}
                        validators={[Validators.required()]}
                        value={_.get(addressDTO, 'street')}
                        ref={(s) => this.streetInput = s}
                    />

                    <NRTFormInput
                        name={'responsible.addressDTO.number'}
                        label={'Número'}
                        type={'number'}
                        value={_.get(addressDTO, 'number')}
                    />

                    <NRTFormInput
                        name={'responsible.addressDTO.complement'}
                        label={'Complemento'}
                        value={_.get(addressDTO, 'complement')}
                    />
                </NRTHorizontalStack>

                <NRTFormInput
                    name={'responsible.addressDTO.neighborhood'}
                    label={'Bairro*'}
                    validators={[Validators.required()]}
                    ref={(i) => this.neighborhoodInput = i}
                    value={_.get(addressDTO, 'neighborhood')}
                />

                <NRTHorizontalStack fractions={[2, 1]}>
                    <NRTFormInput
                        name={'responsible.addressDTO.city'}
                        label={'Cidade*'}
                        validators={[Validators.required()]}
                        ref={(i) => this.cityInput = i}
                        value={_.get(addressDTO, 'city')}
                    />

                    <NRTFormInput
                        name={'responsible.addressDTO.state'}
                        label={'Estado*'}
                        ref={(i) => this.stateInput = i}
                        validators={[Validators.required()]}
                        value={_.get(addressDTO, 'state')}
                    />
                </NRTHorizontalStack>
            </NRTVerticalStack>
        )
    }
}

MCSaleFormResponsible.propTypes = {
    person: PropTypes.object,
}

MCSaleFormResponsible.defaultProps = {}

export default MCSaleFormResponsible



// WEBPACK FOOTER //
// ./src/components/_sale/FormResponsible/index.js